// /assets/section-grid-two-collections.js
(() => {
    const MQ = "(min-width: 1000px)";
    const mq = window.matchMedia(MQ);
    const MAX_SHIFT = 150; // regolabile per intensità
    let sections = [];
    let scrollAttached = false;
    let rafId = null;

    function collectSections(root = document) {
        return Array.from(root.querySelectorAll(".section-grid-two-collections")).map(section => {
            const cards = section.querySelectorAll(".collection-card");
            return {
                section,
                card1: cards[0],
                card2: cards[1],
            };
        });
    }

    function handleParallax() {
        rafId = null;
        if (!mq.matches || !sections.length) return;

        const viewportH = window.innerHeight;
        const scrollY = window.scrollY;

        sections.forEach(({ section, card1, card2 }) => {
            if (!card1 || !card2) return;

            const rect = section.getBoundingClientRect();
            const sectionTop = scrollY + rect.top;
            const sectionH = rect.height;

            // Evita calcoli se la sezione non è visibile
            if (scrollY + viewportH < sectionTop || scrollY > sectionTop + sectionH) return;

            const progress = (scrollY + viewportH - sectionTop) / (sectionH + viewportH); // 0 → 1
            const shift = (progress - 0.5) * 2 * MAX_SHIFT; // da -MAX a +MAX

            const moveDown = (0.6 * shift).toFixed(2); // card1 si muove verso il basso
            const moveUp = (-0.6 * shift).toFixed(2);  // card2 verso l’alto

            card1.style.transform = `translate3d(0, ${moveDown}px, 0)`;
            card2.style.transform = `translate3d(0, ${moveUp}px, 0)`;
        });
    }

    function onScroll() {
        if (rafId == null) rafId = requestAnimationFrame(handleParallax);
    }

    function attachScroll() {
        if (scrollAttached) return;
        window.addEventListener("scroll", onScroll, { passive: true });
        scrollAttached = true;
    }

    function detachScroll() {
        if (!scrollAttached) return;
        window.removeEventListener("scroll", onScroll);
        scrollAttached = false;
    }

    function resetTransforms() {
        sections.forEach(({ card1, card2 }) => {
            [card1, card2].forEach(card => {
                if (card) card.style.transform = "translate3d(0,0,0)";
            });
        });
    }

    function init(root = document) {
        sections = collectSections(root);

        if (mq.matches) {
            attachScroll();
            handleParallax();
        } else {
            detachScroll();
            resetTransforms();
        }
    }

    function boot() {
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", () => init(document), { once: true });
        } else {
            init(document);
        }
    }

    // Bootstrap
    boot();

    // Editor Shopify events
    document.addEventListener("shopify:section:load", e => init(e.target || document));
    document.addEventListener("shopify:section:select", e => init(e.target || document));

    // Responsive switch
    const onMqChange = e => (e.matches ? init(document) : (detachScroll(), resetTransforms()));
    if (mq.addEventListener) mq.addEventListener("change", onMqChange);
    else mq.addListener(onMqChange);
})();
